import "./TituloTabela.css";
export const TituloTabela = (props) => {
  return (
    <div className="tituloTabelaa">
      <strong className="strong" {...props} />
      <p> </p>
    </div>
  );
};
